"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowVersionDomain = void 0;
const firestore_1 = require("firebase/firestore");
const firebase_1 = require("../services/firebase");
const use_upflowy_store_1 = require("../use-upflowy-store");
class FlowVersionDomain {
    constructor(ref) {
        this.ref = ref;
    }
    static findById(flowId, versionId) {
        return new FlowVersionDomain((0, use_upflowy_store_1.upflowyStoreRefs)(firebase_1.db).flows().id(flowId).versions().id(versionId));
    }
    updateTimestamp(transaction) {
        transaction.set(this.ref.ref, {
            updatedAt: new Date().getTime(),
        }, {
            merge: true,
        });
        return transaction;
    }
    async addWebhook(transaction, webhook) {
        const { action, target, stepId, triggerId, async, name, paused, ...rest } = webhook;
        const docRef = (0, firestore_1.doc)(this.ref.webhooks().ref);
        const now = new Date().getTime();
        const pauseVal = paused === undefined ? false : paused;
        await transaction.set(docRef, {
            createdAt: now,
            updatedAt: now,
            action,
            name,
            paused: pauseVal,
            target,
            stepId,
            triggerId,
            async,
            id: docRef.id,
        });
        transaction.set(this.ref.webhooks().id(docRef.id).private().id(docRef.id).ref, {
            ...rest,
            id: docRef.id,
        });
        this.updateTimestamp(transaction);
        return transaction;
    }
    updateWebhook(transaction, webhook) {
        /* eslint-disable @typescript-eslint/no-unused-vars */
        const { createdAt, updatedAt, action, target, stepId, triggerId, async, name, paused, advancedConnectorId, ...rest } = webhook;
        /* eslint-enable */
        const docRef = this.ref.webhooks().id(webhook.id);
        transaction.set(docRef.ref, {
            action,
            async,
            target,
            stepId,
            name,
            triggerId,
            paused,
            ...(advancedConnectorId && { advancedConnectorId }),
            updatedAt: new Date().getTime(),
        }, { merge: true });
        transaction.set(docRef.private().id(webhook.id).ref, {
            ...rest,
            id: webhook.id,
        });
        this.updateTimestamp(transaction);
        return transaction;
    }
    deleteWebhook(transaction, webhookId) {
        const docRef = this.ref.webhooks().id(webhookId);
        transaction.delete(docRef.private().id(webhookId).ref).delete(docRef.ref);
        this.updateTimestamp(transaction);
        return transaction;
    }
    upsertWebhook(transaction, webhook) {
        if ('id' in webhook)
            return this.updateWebhook(transaction, webhook);
        this.addWebhook(transaction, webhook);
        return transaction;
    }
    addTrigger(transaction, entity) {
        const docRef = (0, firestore_1.doc)(this.ref.triggers().ref);
        const now = new Date().getTime();
        transaction.set(docRef, {
            id: docRef.id,
            ...entity,
            createdAt: now,
            updatedAt: now,
        });
        this.updateTimestamp(transaction);
        return docRef;
    }
    updateTrigger(transaction, entity) {
        const { id, ...rest } = entity;
        const docRef = this.ref.triggers().id(id);
        transaction.set(docRef.ref, { ...rest, updatedAt: new Date().getTime() }, { merge: true });
        this.updateTimestamp(transaction);
        return docRef.ref;
    }
    deleteTrigger(transaction, id) {
        const docRef = this.ref.triggers().id(id);
        transaction.delete(docRef.ref);
        this.updateTimestamp(transaction);
        return transaction;
    }
    upsertTrigger(transaction, entity) {
        if ('id' in entity)
            return this.updateTrigger(transaction, entity);
        return this.addTrigger(transaction, entity);
    }
}
exports.FlowVersionDomain = FlowVersionDomain;
//# sourceMappingURL=flow-version-domain.js.map